import styled from '@emotion/styled';
import { getColor } from '../common/UICommon';

export const SignUpBottomTextInput = styled.p`
  font-family: 'Poppins';
  font-size: 14px;
  font-weight: 500;
  color: ${getColor('PURPLE_60')};
  margin-top: 8px;
`;
